/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class BenchmarkIcon extends BaseIcon {
    getChildren = () => [
        <path
            d="M8.5,16A7.5,7.5,0,1,1,16,8.5,7.5,7.5,0,0,1,8.5,16Zm0-14A6.49,6.49,0,0,0,4.76,13.8v0h0A6.5,6.5,0,1,0,8.5,2Zm2.75,6.75c0-.05,0-.09,0-.13a2.77,2.77,0,0,0-5.53,0L4,7.59a4.61,4.61,0,0,1,9,0ZM7.65,11.3,8.19,7h.62l.54,4.3a1,1,0,0,1,.08.39.43.43,0,0,1,0,.11l0,.2H9.37a.93.93,0,0,1-1.75,0H7.56l0-.19s0-.08,0-.12A.86.86,0,0,1,7.65,11.3Z"
            fill={this.getColor()}/>]
    getViewBox = () => '0 0 16 16'
}
